export default __webpack_public_path__ + "static/media/agent-role-ceo-grey.2d159c05.svg";